import { defineMessages, useIntl } from "react-intl"
import { AnimatedStage } from "src/components"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useVehicleDetailsContextForStage } from "src/screens/vehicleDetails/context/VehicleDetailsContext"
import { useEditActionButton } from "../../hooks/useEditActionButton"
import { SpecialEquipment } from "./components/SpecialEquipment"
import { SpecialEquipmentStageSkeleton } from "./components/SpecialEquipmentStageSkeleton"
import { useSpecialEquipmentStage } from "./hooks/useSpecialEquipmentStage/useSpecialEquipmentStage"
import { SpecialEquipmentEditContainer } from "./specialEquipmentEditContainer/SpecialEquipmentEditContainer"

const messages = defineMessages({
	title: {
		defaultMessage: "Special Equipment",
		id: "vehicleDetails.overview.equipment.title",
	},
})

export const SpecialEquipmentContainer = withErrorHandler(() => {
	const { mode } = useVehicleDetailsContextForStage("equipment")
	const { formatMessage } = useIntl()
	const { editAction, editEquipmentView, handleClick, isLoading, leaveEditStage, view } = useSpecialEquipmentStage()

	const actionButton = useEditActionButton("equipment", editAction, {
		fetch: handleClick,
		isLoading,
	})

	return (
		<AnimatedStage title={formatMessage(messages.title)} actionButtons={actionButton}>
			<ErrorNotificationInline dismissButton={false} />
			{view === undefined ? (
				<SpecialEquipmentStageSkeleton />
			) : view === null ? null : mode === "edit" && editEquipmentView ? (
				<SpecialEquipmentEditContainer view={editEquipmentView} leaveEditStage={leaveEditStage} />
			) : (
				<SpecialEquipment view={view} />
			)}
		</AnimatedStage>
	)
})
